import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { lastValueFrom, take } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { KycSession, IDENTITY_CONSENT_TERMS_VERSION, KycConsentRequest } from '../models/identity-verification.model';

export interface KidKycSimulateRequest {
  success?: boolean;
  documentCountry?: string;
  birthDate?: string;
  firstName?: string;
  lastName?: string;
}

export interface KidVerificationResult {
  kidId: string;
  verified: boolean;
  tier: string;
}

@Injectable({ providedIn: 'root' })
export class KidVerificationService {
  #http = inject(HttpClient);

  createSession(kidId: string, consent?: KycConsentRequest): Promise<KycSession> {
    return lastValueFrom(
      this.#http
        .post<KycSession>(
          `${environment.baseUrl}/user/kid/${encodeURIComponent(kidId)}/kyc/session`,
          {
            consentAccepted: consent?.consentAccepted ?? true,
            termsVersion:
              consent?.termsVersion ?? IDENTITY_CONSENT_TERMS_VERSION,
            password: consent?.password ?? '',
            totpCode: consent?.totpCode ?? '',
          },
        )
        .pipe(take(1)),
    );
  }

  loadSession(kidId: string): Promise<KycSession> {
    return lastValueFrom(
      this.#http
        .get<KycSession>(
          `${environment.baseUrl}/user/kid/${encodeURIComponent(kidId)}/kyc/session`,
        )
        .pipe(take(1)),
    );
  }

  simulateVerification(
    kidId: string,
    dto: KidKycSimulateRequest,
  ): Promise<KidVerificationResult> {
    return lastValueFrom(
      this.#http
        .post<KidVerificationResult>(
          `${environment.baseUrl}/user/kid/${encodeURIComponent(kidId)}/kyc/simulate`,
          {
            success: dto.success !== false,
            documentCountry: dto.documentCountry ?? '',
            birthDate: dto.birthDate ?? '',
            firstName: dto.firstName ?? '',
            lastName: dto.lastName ?? '',
          },
        )
        .pipe(take(1)),
    );
  }
}
